import { SAVED_SEARCH_DISTRIBUTION_TABLE_LABEL } from '../saved-search-designer/constants/editor.constants';

export const RECENT_ITEMS_QUANTITY = 5;

export const SMARTINSIGHT_REPORT_LIST_SEARCH_NAME = 'All Reports';
export const SMARTINSIGHT_REPORT_MODELS_SEARCH_NAME = 'All Report Models';
export const SAVED_SEARCH_LIST_SEARCH_NAME = 'All Saved Searches';

export const OPTION_STORE_ENTITY_NAME = 'OptionStore';
export const DOCUMENT_REPOSITORIES_ENTITY_NAME = 'Document Repositories';
export const SAVED_SEARCH_ENTITY_NAME = 'Document Repositories';

export const SAVED_SEARCHES_SMARTINSIGHT_TYPE = 'savedSearches';
export const REPORTS_SMARTINSIGHT_TYPE = 'reports';
export const REPORT_MODELS_SMARTINSIGHT_TYPE = 'reportModels';

export const QPS_SUPERVISOR_RIGHT = 'QPS_SUPERVISOR';
export const QPS_MANAGE_RIGHT = 'QPS_MANAGE';

export const DISTRIBUTION_TYPE_ACTOR = 0;
export const DISTRIBUTION_TYPE_ADMIN_ROLE = 0;
export const DISTRIBUTION_TYPE_ROLE = 1;
export const DISTRIBUTION_TYPE_ADMIN_EVERYONE = 1;
export const DISTRIBUTION_TYPE_ORG_UNIT = 2;
export const DISTRIBUTION_TYPE_ORGANIZATION = 3;
export const DISTRIBUTION_TYPE_EVERYONE = 4;
const DISTRIBUTION_TYPE_SELF = 5;

export const DISTRIBUTION_CODE = 'code';
export const DISTRIBUTION_NAME = 'name';

export const GET_SMARTINSIGHT_REPORTS_ENDPOINT = '/getsmartinsightreports';

export const ADMIN_DISTRIBUTION_OPTIONS = [
  {
    label: 'Role',
    value: DISTRIBUTION_TYPE_ADMIN_ROLE,
  },
  {
    label: 'Everyone',
    value: DISTRIBUTION_TYPE_ADMIN_EVERYONE,
  },
];

export const VIEWER_DISTRIBUTION_OPTIONS = [
  {
    label: 'Actor',
    value: DISTRIBUTION_TYPE_ACTOR,
  },
  {
    label: 'Role',
    value: DISTRIBUTION_TYPE_ROLE,
  },
  {
    label: 'Organization Unit',
    value: DISTRIBUTION_TYPE_ORG_UNIT,
  },
  {
    label: 'Everyone',
    value: DISTRIBUTION_TYPE_EVERYONE,
  },
  {
    label: 'Self',
    value: DISTRIBUTION_TYPE_SELF,
  },
];

export const ADMIN_DISTRIBUTION_FOR_DETAILS = {
  [DISTRIBUTION_TYPE_ADMIN_ROLE]: {
    title: 'Roles',
    entityName: 'Role',
    savedSearchName: '',
    mappingFields: {
      id: 'ROL_ID',
      code: 'ROL_CODE',
      name: 'ROL_NAME',
    },
  },
};

export const DISTRIBUTION_FOR_DETAILS = {
  [DISTRIBUTION_TYPE_ACTOR]: {
    title: 'Actors',
    entityName: 'Actor',
    savedSearchName: '',
    mappingFields: {
      id: 'ACT_ID',
      code: 'RSR_CODE',
    },
  },
  [DISTRIBUTION_TYPE_ROLE]: {
    title: 'Roles',
    entityName: 'Role',
    savedSearchName: '',
    mappingFields: {
      id: 'ROL_ID',
      code: 'ROL_CODE',
      name: 'ROL_NAME',
    },
  },
  [DISTRIBUTION_TYPE_ORG_UNIT]: {
    title: 'Organization Unit',
    entityName: 'ORU_ORG_UNIT',
    savedSearchName: '',
    mappingFields: {
      id: 'ORU_ID',
      code: 'ORU_CODE',
      name: 'ORU_NAME',
    },
  },
};

export const DISTRIBUTION_FOR_WITH_TABLE = [
  DISTRIBUTION_TYPE_ACTOR,
  DISTRIBUTION_TYPE_ADMIN_ROLE,
  DISTRIBUTION_TYPE_ROLE,
  DISTRIBUTION_TYPE_ORG_UNIT,
];

export const DISTRIBUTION_TABLE_VALIDATION_PROPS = [
  {
    prop: DISTRIBUTION_CODE,
    errorLabel: 'Code',
    required: true,
    unique: true,
    tableName: SAVED_SEARCH_DISTRIBUTION_TABLE_LABEL,
  },
];
